// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;Lift up your hands towards the sanctuary&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and bless the Lord.<br> </p> </div></div>";
// Exports
module.exports = code;